<template>
  <div style="width: 200px;margin-left: 5px;padding: 5px;overflow: auto;padding-bottom:20px;" class="border">
    <!--探头选择-->
    <el-select v-model="form.code" @change="probeChange" class="mb-10">
      <el-option
        :value="probe.code"
        :label="probe.name"
        :key="probe.code"
        v-for="probe in probeList"
      ></el-option>
    </el-select>
    <template v-if="currentProbe">
      <div class="mb-5">{{ currentProbe.plinthCode }}</div>
      <div class="mb-5">{{ currentProbe.description }}</div>
    </template>
    <el-radio-group
      class="w-100 mb-10"
      v-model="form.probe"
      @change="unitChange"
    >
      <template v-if="currentProbe && currentProbe.deviceCatalog === 0">
        <el-radio-button label="temp">{{ $t('integration.temperature') }}</el-radio-button>
        <el-radio-button label="hum" :disabled="!isHum(currentProbe)"
          >{{ $t('integration.humidity') }}
        </el-radio-button>
      </template>
      <template v-else-if="currentProbe && currentProbe.deviceCatalog === 5">
        <el-radio-button label="gas">{{ $t('route.gas') }}</el-radio-button>
      </template>
      <template v-else-if="currentProbe && currentProbe.deviceCatalog === 6">
        <el-radio-button label="magnetism">{{ $t('route.magnetism') }}</el-radio-button>
      </template>
    </el-radio-group>
    <template v-if="timeRange && timeRange.start">
      <el-row>
        <el-row class="uk-margin-small-bottom">
          <el-col :span="10">{{ $t('integration.maximum') }}</el-col>
          <el-col :span="8" v-if="minMax.max"
            >{{ minMax.max }}{{ customUnit[form.probe] }}
          </el-col>
        </el-row>

        <el-row class="uk-margin-small-bottom">
          <el-col :span="10">{{ $t('integration.minimum_value') }}</el-col>
          <el-col :span="8" v-if="minMax.min"
            >{{ minMax.min }}{{ customUnit[form.probe] }}
          </el-col>
        </el-row>

        <el-row class="uk-margin-small-bottom">
          <el-col :span="10">{{ $t('integration.average_value') }}</el-col>
          <el-col :span="8"
            >{{ minMax.avg }}{{ customUnit[form.probe] }}
          </el-col>
        </el-row>

        <el-row class="uk-margin-small-bottom">
          <el-col :span="10">{{ $t('integration.abnormal') }}</el-col>
          <el-col :span="8">{{ minMax.ex }}</el-col>
        </el-row>

        <el-row class="uk-margin-small-bottom">
          <el-col :span="10">{{ $t('integration.storage') }}</el-col>
          <el-col :span="8">{{ minMax.store }}</el-col>
        </el-row>
      </el-row>

      <el-checkbox
        class="mb-5"
        v-model="isShowBuffer"
        @change="showBufferChange"
        >{{ $t('integration.display_buffer_interval') }}
      </el-checkbox>
      <el-select v-model="bufferRange" class="mb-10">
        <el-option
          :value="item"
          :label="item.name"
          :key="item.id"
          v-for="item in bufferRanges"
        ></el-option>
      </el-select>

      <!--        Probe Time List-->
      <div class="mt-5 mb-10" :key="item.id" v-for="item in selectedProbe">
        <div class="uk-margin-small-bottom">{{ item.deviceCode }}</div>
        <template v-if="timeRange">
          <div class="uk-margin-small-bottom">
            {{ $t('integration.from') }}:{{ $timetransition(timeRange.start) }}
          </div>
          <div>{{ $t('integration.to') }}:{{ $timetransition(timeRange.end) }}</div>
        </template>
      </div>

      <!-- ProbeList -->
      <div class="mt-5" v-if="otherProbeList.length">
        <div class=" lh-30 pl-5  bd-t bd-l bd-r">
          <!--        <el-checkbox v-model="isCompare">{{ $t('启用数据比较') }}</el-checkbox>-->

          <div>{{ $t('integration.data_compare') }}</div>
        </div>
        <div class="border" style="padding: 5px">
          <div
            class="lh-30 border pl-5 mb-5 compare-div"
            :key="probe.id"
            v-for="(probe, index) in otherProbeList"
            :title="probe.name"
          >
            <el-checkbox
              v-model="compare[index]"
              @change="otherProbeChange"
              :true-label="probe.code || null"
              :false-label="null"
              >{{ probe.name }}
            </el-checkbox>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <el-empty :description="$t('messageTitle.PleaseChooseATime')"></el-empty>
    </template>
  </div>
</template>

<script>
import { carrierRelectList } from '@/api/modules/carrier'

import { isHum, isSensor, isSensor2 } from '@/utils/sensor/sensorUtil'
import { defaultUnit } from '@/utils/convert'

export default {
  props: {
    // carrierType  carrierId
    carrierInfo: {
      type: Object,
      required: true
    },
    minMax: {
      //  min max avg ex store
      type: Object
    },
    timeRange: {
      // start end
      type: Object
    },
    customUnit:{
      type: Object
    }
  },
  watch: {
    bufferRange () {
      this.$emit('showBuffer', this.bufferRange, this.isShowBuffer)
    }
  },
  data () {
    return {
      // 是否显示缓冲区间
      isShowBuffer: false,
      // 当前选中的缓冲区间
      bufferRange: null,
      // 是否启用数据比较
      isCompare: null,
      // 数据比较
      compare: [],
      form: {
        code: '',
        devCatalog: '',
        carrierId: '',
        probe: 'temp'
      },
      probeList: []
    }
  },
  computed: {
    defaultUnit () {
      return defaultUnit
    },
    // 排除了已选择的探头 的探头列表
    otherProbeList () {
      // 因为新增了气体和门磁，同类的才可以比较
      return this.probeList.filter(probe => probe.code !== this.form.code && probe.deviceCatalog === this.form.devCatalog)
    },
    // 当前选中的探头
    currentProbe () {
      return this.probeList.find(probe => probe.code === this.form.code)
    },
    selectedProbe () {
      const compareList = JSON.parse(JSON.stringify(this.compare))
      compareList.push(this.form.code)

      return this.probeList.filter(
        item => compareList.indexOf(item.code) !== -1
      )
    },
    // 当前选中探头的缓冲区间
    bufferRanges () {
      return (this.currentProbe && this.currentProbe.bufferRanges) || []
    }
  },
  methods: {
    isHum,
    /**
     * 清空数据比较
     */
    clearCompare () {
      this.compare = this.compare.map(item => null)
    },
    /**
     * 是否显示缓冲区间状态被改变
     * @param status
     */
    showBufferChange (status) {
      this.$emit('showBuffer', this.bufferRange, status)
    },
    /**
     * 单位被改变
     */
    unitChange () {
      this.compare = this.compare.map(item => null)

      this.$emit('probeChange', this.form, [this.form.code])
    },
    /**
     * 探头被选择
     */
    getProbeList () {
      const { carrierType, carrierId } = this.carrierInfo
      this.form.carrierId = carrierId
      carrierRelectList(carrierType, carrierId).then(({ result }) => {
        // this.probeList = result.filter(item => isSensor(item))
        this.probeList = result.filter(item => isSensor2(item))
        if (this.probeList.length) {
          this.form.code = this.probeList[0].code
          // 气体和门磁的probe不一样
          if(this.probeList[0].deviceCatalog === 0){
            this.form.probe = 'temp'
          }else if(this.probeList[0].deviceCatalog === 5){
            this.form.probe = 'gas'
          }else{
            this.form.probe = 'magnetism'
          }
          this.$emit('probeChange', this.form, [this.form.code])
        }
      })
    },
    probeChange (code) {
      const item = this.probeList.find(item => item.code === code)
      this.form.devCatalog = item.deviceCatalog
      this.form.code = item.code
      this.form.token = ''
      this.isRenderChart = true
      // 气体和门磁的probe不一样
      if(this.currentProbe.deviceCatalog === 0){
        this.form.probe = 'temp'
      }else if(this.currentProbe.deviceCatalog === 5){
        this.form.probe = 'gas'
      }else{
        this.form.probe = 'magnetism'
      }

      const selected = JSON.parse(JSON.stringify(this.compare))
      selected.push(this.form.code)
      this.$emit('probeChange', this.form, selected)
    },
    otherProbeChange (code) {
      this.$emit(
        'otherProbeChange',
        JSON.parse(JSON.stringify(this.compare)),
        code
      )
    }
  },
  mounted () {
    this.getProbeList()
    if (!this.form.code && this.probeList.length) {
      this.$emit('probeChange', this.probeList[0].code)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-radio-button {
  width: 50%;

  .el-radio-button__inner {
    width: 100%;
  }
}
.compare-div{
  ::v-deep .el-checkbox__label{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 135px;
    line-height: 1;
  }
}
</style>
